const animation = {
  v: "5.9.0",
  fr: 60,
  ip: 0,
  op: 25,
  w: 24,
  h: 36,
  nm: "collapseBar",
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "Calque de forme 1",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [12, 18, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 0,
            s: [{
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-10.017, -0.016], [0.062, 0.008], [9.998, 0.055]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 1,
            s: [{
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-10.025, -3.117], [0.062, 2.758], [9.99, -3.047]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 13,
            s: [{
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-10.017, -0.016], [0.062, 0.008], [9.998, 0.055]],
              c: false
            }]
          }, {
            t: 25,
            s: [{
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-10.025, 2.984], [0.078, -2.652], [9.998, 3.051]],
              c: false
            }]
          }],
          ix: 2
        },
        nm: "Tracé 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.886274509804, 0.909803921569, 0.941176470588, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 6,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: "Contour 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 90,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transformer "
      }],
      nm: "Polyétoile 1",
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 90,
    st: 0,
    bm: 0
  }],
  markers: []
};
export default animation;
//# sourceMappingURL=collapseBar.js.map